import { render, staticRenderFns } from "./DeleteRoomDecorationRecord.vue?vue&type=template&id=019772e8&scoped=true"
import script from "./DeleteRoomDecorationRecord.vue?vue&type=script&lang=js"
export * from "./DeleteRoomDecorationRecord.vue?vue&type=script&lang=js"
import style0 from "./DeleteRoomDecorationRecord.vue?vue&type=style&index=0&id=019772e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019772e8",
  null
  
)

export default component.exports